























import {Component, Prop, Vue} from 'vue-property-decorator';
import Product from "@/api/Product";
import RenderPrice from "@/components/Shared/RenderPrice.vue";

@Component({
  components: {RenderPrice}
})
export default class RenderProductPrice extends Vue {
  @Prop() private product!: Product;

  hasSpecialPrice(): boolean {
    return this.product.price != this.product.specialPrice;
  }

  isAvailable(): boolean {
    return this.product.stockStatus == 1;
  }
}
